export const circle = {
  visible: true,
  active: false,
  invalidated: true,
  handles: {
    start: {
      x: "",
      y: "",
      highlight: true,
      active: false,
    },
    end: {
      x: "",
      y: "",
      highlight: true,
      active: false,
    },
    initialRotation: 0,
    textBox: {},
  },
};
